import React from 'react'

function ViewHistory() {
  return (
    <div className='pt-40'>index</div>
  )
}

export default ViewHistory